var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99967 3.95117C8.99967 3.39889 8.55196 2.95117 7.99967 2.95117C7.44739 2.95117 6.99967 3.39889 6.99967 3.95117V7.61784H3.33301C2.78072 7.61784 2.33301 8.06555 2.33301 8.61784C2.33301 9.17012 2.78072 9.61784 3.33301 9.61784H6.99968V13.2845C6.99968 13.8368 7.44739 14.2845 7.99968 14.2845C8.55196 14.2845 8.99968 13.8368 8.99968 13.2845V9.61784H12.6663C13.2186 9.61784 13.6663 9.17012 13.6663 8.61784C13.6663 8.06555 13.2186 7.61784 12.6663 7.61784H8.99967V3.95117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.2ca2b5396a4c1a4829509c5106d6df86.svg";
export { ForwardRef as ReactComponent };